export class CreateShareForUnregisteredDto {

  email?: string;
  phoneNumber: string;
  name: string;
  organiserAccount_id: string;
  template_id: string;
  /** Same field check-in create uses; backend copies purpose onto account-share.formName. */
  templateId?: string;
  formName: string;

}
